import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs-compat/add/observable/empty';

@Injectable({
  providedIn: 'root',
})
export class ImportCsvService {

  csvTojson(fileList: FileList, delimiter: string, functionHandle?: Function): Observable<any> {
    const fileInfo: any = fileList[0];
    const reader: FileReader = new FileReader();

    reader.readAsText(fileInfo);
    const response: Observable<any> = new Observable(observer => {

      reader.onload = (data) => {
        const matriz: any = [];

        const csvData: any = reader.result;
        const csvRecordsArray: any = String(csvData).split(/\r\n|\n/);

        const header: any = csvRecordsArray[0].split(delimiter);
        for (let cont = 1; cont < csvRecordsArray.length; cont++) {
          const line: any = csvRecordsArray[cont]
                          .split(delimiter)
                          .filter((record) => record != null && record.trim().length > 0)
                          .map((record) => record.trim());

        if (line.length > 0) {
            const jsonObj: any = {};
            for (let index = 0; index < line.length; index++) {
              jsonObj[header[index]] = line[index];
            }
            matriz.push(jsonObj);
          }
        }

        const csvInfo: any = {
          data: matriz,
          fileName: fileInfo.name,
        };
        observer.next(csvInfo);
      };
    });

    return response;
  }

  csvTojson2(fileList: FileList, delimiter: string, functionHandle?: Function): Observable<any> {
    const fileInfo: any = fileList[0];
    const reader: FileReader = new FileReader();

    reader.readAsText(fileInfo);
    const response: Observable<any> = new Observable(observer => {

      reader.onload = (data) => {
        const matriz: any = [];

        const csvData: any = reader.result;
        const csvRecordsArray: any = String(csvData).split(/\r\n|\n/);

        const header: any = csvRecordsArray[0].split(delimiter);
        for (let cont = 1; cont < csvRecordsArray.length; cont++) {
          const line: any = csvRecordsArray[cont]
                          .split(delimiter)
                          .filter((record) => record != null)
                          .map((record) => record.trim());

          if (line.length > 0) {
            const jsonObj: any = {};
            let isEmpty = true;
            for (let index = 0; index < line.length; index++) {
              if(line[index] != null && line[index].trim().length > 0) {
                isEmpty = false;
              }
              jsonObj[header[index]] = line[index];
            }
            if(!isEmpty) {
              matriz.push(jsonObj);
            }
          }
        }

        const csvInfo: any = {
          data: matriz,
          fileName: fileInfo.name,
        };
        observer.next(csvInfo);
      }
    });

    return response;
  }


  /**
   * Validate the csv structure. (Number of header parameters and number of information in lines)
   * @param fileList
   * @param delimiter
   * @returns Observable object with 'isValid' (true or false) and 'linesErr' string that contains the numbers of the invalid lines
   */
  validCsvStructure(fileList: FileList, delimiter: string): Observable<any> {
    const fileInfo: any = fileList[0];
    const reader: FileReader = new FileReader();
    reader.readAsText(fileInfo);

    const response: Observable<any> = new Observable(observer => {
      reader.onload = (data) => {
        const csvData: any = reader.result;
        const csvRecordsArray: any = String(csvData).split(/\r\n|\n/);

        const header: any = csvRecordsArray[0].split(delimiter);
        const headerSize: any = header.length;

        let linesErr: any = "";
        let valid = true;
        for (let line = 1; line < csvRecordsArray.length; line++) {
          if (csvRecordsArray[line].length > 0) { //desconsidera linhas vazias
            const lineInfo: any = csvRecordsArray[line].split(delimiter);
            if (lineInfo.length != headerSize) {
              linesErr = linesErr + ", " + (line+1);
              valid = false;
            }
          }
        }
        const structureInfo: any = {
          isValid: valid,
          linesErr: linesErr.substring(2),
        };
        observer.next(structureInfo);
      };
    });

    return response;
  }


  /**
   * Converts the information from the input csv 'fileList' to a json structure. (without validations)
   * @param fileList
   * @param delimiter
   * @param functionHandle
   * @returns Observable object with 'fileName' and 'data' that contains the content from the csv at a json structure
   */
  csvToJsonAll(fileList: FileList, delimiter: string): Observable<any> {
    const fileInfo: any = fileList[0];
    const reader: FileReader = new FileReader();
    reader.readAsText(fileInfo);

    const response: Observable<any> = new Observable(observer => {
      reader.onload = (data) => {
        const matriz: any = [];
        const csvData: any = reader.result;
        const csvRecordsArray: any = String(csvData).split(/\r\n|\n/);

        const header: any = csvRecordsArray[0].split(delimiter);

        for (let cont = 1; cont < csvRecordsArray.length; cont++) {
          if (csvRecordsArray[cont].length > 0) {  //desconsidera linhas vazias
            const line: any = csvRecordsArray[cont].split(delimiter);
            if (line.length > 0) {
              const jsonObj: any = {};
              for (let index = 0; index < line.length; index++) {
                jsonObj[header[index]] = line[index];
              }
              matriz.push(jsonObj);
            }
          }
        }

        const jsonInfo: any = {
          data: matriz,
          fileName: fileInfo.name,
        };
        observer.next(jsonInfo);
      };
    });

    return response;
  }

}
